import storeRoot from '../store-root'
import http from '../../services/http'

const moduleName = 'autoControl'

storeRoot.registerModule(moduleName, {
  namespaced: true,
  state: {

  },
  actions: {
    // 编辑获取时间控制数据
    async getTimeControlData ({ commit }, payload) {
      let result = await http.get(
        `/api/EquipmentSocket/GetSwithEditView?equipmentId=${payload}`
      )
      return result.data
    },
    // 更新时间控制数据
    async updateTimeControlData ({ commit }, payload) {
      let result = await http.put(
        `/api/EquipmentSocket/UpdateSwith`, payload
      )
      return result.data
    },
    // 编辑获取水质参数控制数据
    async getlimitControlData ({ commit }, payload) {
      let result = await http.get(
        `/api/SwithLimit/GetEditSwithLimit?sensorEquipmentId=${payload}`
      )
      return result.data
    },
    // 更新水质参数控制数据
    async updatelimitControlData ({ commit }, payload) {
      let result = await http.post(`/api/SwithLimit/UpdateSwithLimit`, payload)
      return result.data
    }

  },
  mutations: {
  }

})

export default moduleName
